import { render } from "./AffiliateConfiguration.vue?vue&type=template&id=58f0088c&scoped=true"
import script from "./AffiliateConfiguration.vue?vue&type=script&lang=js"
export * from "./AffiliateConfiguration.vue?vue&type=script&lang=js"

import "./AffiliateConfiguration.vue?vue&type=style&index=0&id=58f0088c&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f0088c"]])

export default __exports__